import React from "react";
import AllPackages from "../../components/home/AllPackageComp";


export default function AllPackagesCTR() {
  return <AllPackages />;
}
